// The Comic Machine - Layer

var Layer = (function() {

  // A Layer object to be managed by the Layer Manager
  function Layer(options) {

    options = options || {};

    var width = options.width || null;
    var height = options.height || null;
    var scale = options.scale || 1;
    var self = this;

    // Assign the parent page, if one is associated
    this.page = options.page || null;

    // Layer meta and content
    this.uid = options.uid || generateUUID();
    this.name = options.name || "";
    this.type = options.type || null;
    this.action = options.action || Layer.Actions.MOVE;
    this.content = options.content || null;
    this.asset = options.asset || null;

    var isText = this.type === 3;

    // Load initial content
    // if (this.content !== null) {}

    // Create the canvas
    this.canvas = new Canvas({
      uuid: this.uuid,
      page: this.page,
      layer: this,
      width: width,
      height: height,
      scale: scale,
    });

    // Timing
    this.delay = options.delay || (isText ? 250 : 0);
    this.duration = options.duration || 500;

    // Position, size and scale
    this.size = {
      width: width,
      height: height,
    };
    this.position = {
      x: options.x || 0,
      y: options.y || 0,
    };
    this.offset = {
      x: 0,
      y: 0,
    };
    this.scale = scale;

    this.text = options.text || {
      value: "",
    };

    this.isScaling = false;
    this.isMoving = false;

    // Transition data
    this.transition = options.transition || {};

    if (!this.transition.start) {
      this.transition.start = {
        set: false,
      };
    } else {
      this.transition.start.set = true;
    }
    if (!this.transition.start.x && this.transition.start.x !== 0) {
      this.transition.start.x = this.position.x;
    }
    if (!this.transition.start.y && this.transition.start.y !== 0) {
      this.transition.start.y = this.position.y;
    }
    if (!this.transition.start.width && this.transition.start.width !== 0) {
      this.transition.start.width = this.size.width;
    }
    if (!this.transition.start.height && this.transition.start.height !== 0) {
      this.transition.start.height = this.size.height;
    }
    if (!this.transition.start.opacity && this.transition.start.opacity !== 0) {
      this.transition.start.opacity = 0;
    }

    if (!this.transition.end) {
      this.transition.end = {
        set: false,
      };
    } else {
      this.transition.end.set = true;
    }
    if (!this.transition.end.x && this.transition.end.x !== 0) {
      this.transition.end.x = this.position.x;
    }
    if (!this.transition.end.y && this.transition.end.y !== 0) {
      this.transition.end.y = this.position.y;
    }
    if (!this.transition.end.width && this.transition.end.width !== 0) {
      this.transition.end.width = this.size.width;
    }
    if (!this.transition.end.height && this.transition.end.height !== 0) {
      this.transition.end.height = this.size.height;
    }
    if (!this.transition.end.opacity && this.transition.end.opacity !== 0) {
      this.transition.end.opacity = 1;
    }

    if (!this.transition.easing) {
      this.transition.easing = isText ? "easeOut" : "easeInOut";
    }

    // Set the transition state to preview while editing
    this.preview = options.preview || "start";

    // Looping
    this.loop = options.loop || 0;
    this.reverse = options.reverse || false;

    // Handle layer edits
    this.original = options.original || null;
    this.edits = options.edits || [];

    // Remove after settings
    this.removeAfter = options.removeAfter || {
      type: "none",
      delay: 0,
      duration: this.type == Layer.Types.TEXT ? 1 : -1,
    };

    // Generate the initial thumbnail image
    this.updateThumbnail();

  }

  // Enum of possible Types that the Layer can represent
  Layer.Types = Object.freeze({
    "BASE": 1,
    "IMAGE": 2,
    "TEXT": 3,
    "BUBBLE": 4
  });

  // Enum of possible Actions that the Layer can perform
  Layer.Actions = Object.freeze({
    "ADD": 1,
    "REMOVE": 2,
    "MOVE": 3,
    // "ZOOM": 4,
    // "ROTATE": 5,
    // "PARALLAX": 6,
    // "INSPECT": 7,
    // "LINK": 8,
    // "WAIT": 9,
    // "REMOVE_ALL": 10
  });

  // Collection of Text Bubbles to draw
  Layer.Bubbles = Object.freeze({
    "thought": [
      ["setLineDash", [0, 0]],
      ["beginPath", null],
      ["moveTo", [580.5, 169.9]],
      ["bezierCurveTo", [580.5, 153.8, 571.2, 139.2, 556.3, 128.6]],
      ["bezierCurveTo", [561.1, 123.6, 563.9, 117.6, 563.9, 111.2]],
      ["bezierCurveTo", [563.9, 99.6, 554.9, 89.5, 541.5, 84.1]],
      ["bezierCurveTo", [541.5, 83.3, 541.6, 82.4, 541.6, 81.5]],
      ["bezierCurveTo", [541.6, 49.1, 504.0, 22.8, 457.6, 22.8]],
      ["bezierCurveTo", [445.5, 22.8, 434.1, 24.6, 423.7, 27.8]],
      ["bezierCurveTo", [415.7, 19.4, 402.1, 13.9, 386.6, 13.9]],
      ["bezierCurveTo", [376.6, 13.9, 367.4, 16.3, 359.9, 20.2]],
      ["bezierCurveTo", [341.2, 8.4, 314.1, 1.0, 284.1, 1.0]],
      ["bezierCurveTo", [255.0, 1.0, 228.8, 7.9, 210.2, 19.0]],
      ["bezierCurveTo", [203.1, 15.8, 194.8, 13.9, 185.8, 13.9]],
      ["bezierCurveTo", [170.8, 13.9, 157.6, 19.1, 149.5, 27.0]],
      ["bezierCurveTo", [139.9, 24.3, 129.3, 22.8, 118.2, 22.8]],
      ["bezierCurveTo", [72.9, 22.8, 36.0, 47.9, 34.4, 79.3]],
      ["bezierCurveTo", [19.6, 84.4, 9.3, 95.0, 9.3, 107.3]],
      ["bezierCurveTo", [9.3, 115.3, 13.7, 122.6, 20.8, 128.1]],
      ["bezierCurveTo", [8.5, 138.4, 1.0, 151.6, 1.0, 166.0]],
      ["bezierCurveTo", [1.0, 180.2, 8.2, 193.2, 20.1, 203.4]],
      ["bezierCurveTo", [16.1, 208.0, 13.7, 213.5, 13.7, 219.4]],
      ["bezierCurveTo", [13.7, 232.7, 25.6, 244.0, 42.4, 248.5]],
      ["bezierCurveTo", [42.4, 249.2, 42.3, 249.8, 42.3, 250.5]],
      ["bezierCurveTo", [42.3, 283.0, 79.9, 309.3, 126.3, 309.3]],
      ["bezierCurveTo", [136.9, 309.3, 147.1, 307.9, 156.5, 305.3]],
      ["bezierCurveTo", [164.4, 314.1, 178.3, 319.9, 194.1, 319.9]],
      ["bezierCurveTo", [203.0, 319.9, 211.1, 318.1, 218.0, 315.0]],
      ["bezierCurveTo", [236.1, 324.1, 259.7, 329.6, 285.7, 329.6]],
      ["bezierCurveTo", [310.8, 329.6, 333.8, 324.4, 351.7, 315.8]],
      ["bezierCurveTo", [358.1, 318.4, 365.7, 319.9, 373.7, 319.9]],
      ["bezierCurveTo", [392.1, 319.9, 407.9, 312.1, 414.6, 301.0]],
      ["bezierCurveTo", [427.2, 306.2, 441.9, 309.3, 457.6, 309.3]],
      ["bezierCurveTo", [504.0, 309.3, 541.6, 283.0, 541.6, 250.5]],
      ["bezierCurveTo", [541.6, 249.2, 541.5, 247.8, 541.4, 246.5]],
      ["bezierCurveTo", [554.8, 241.1, 563.9, 231.0, 563.9, 219.4]],
      ["bezierCurveTo", [563.9, 215.3, 562.8, 211.3, 560.7, 207.7]],
      ["bezierCurveTo", [573.0, 197.5, 580.5, 184.3, 580.5, 169.9]],
      ["closePath", null],
      ["lineWidth", 4.0],
      ["strokeStyle", "rgb(0, 0, 0)"],
      ["stroke", null],
      ["fillStyle", "rgb(255, 255, 255)"],
      ["fill", null],
    ]
  });

  // Method to add/insert a new layer to the current page
  Layer.addLayer = function(page, layer, index, options) {
    options = options || {};
    options.page = options.page || page;
    // Use provided layer or create new layer with passed params
    layer = layer || new Layer(options);
    // Insert or add a new layer
    if (index) {
      // Insert a new layer
      page.pageLayers.splice(index, 0, layer);
    } else {
      // Get new index based on current count
      index = page.pageLayers.length;
      // Add a new layer
      page.pageLayers.push(layer); // unshift
    }
    if (!options.deselect) {
      // Select the newly added page
      Layer.selectLayer(page, index);
    }
    // Render the page
    page.renderPage();
    // Update the UI
    Events.global.emit("tcm.layer.update");
    return layer;
  };

  // Method to remove a layer from the current page
  Layer.removeLayer = function(page, index) {

    if (!index) {
      return;
    }

    // Remove the layer
    var layer = page.pageLayers.splice(index, 1)[0];
    var uid = layer.original;
    var original = page.getLayerByUID(uid);

    if (original) {
      var removed = original.edits.splice(original.edits.indexOf(layer.uid), 1);
      // HACK
      original.edits.splice(original.edits.indexOf(layer.uid), 1);
    }

    // Render the page
    page.renderPage();

    // Update the UI
    Events.global.emit("tcm.layer.update");

  };

  // Method to change layers
  Layer.selectLayer = function(page, index) {
    if (index === undefined) {
      return;
    }
    // Update layer index
    page.layerIndex = index;
    // Update the UI
    Events.global.emit("tcm.layer.update");
    // Return the layer
    return page.currentLayer();
  };

  // Method to set layer/canvas size
  Layer.prototype.setSize = function(width, height, update) {

    // Set canvas size
    this.canvas.setSize(width, height);

    // Set layer
    this.size.width = width;
    this.size.height = height;

    // console.log("setSize", width, height, update);

    if (update === true) {
      this.canvas.drawImage(this.content, null, {
        x: width,
        y: height
      });
    } else {
      // Set initial transition sizes
      if (!this.transition.start) {
        this.transition.start = {
          set: false,
          width: width,
          height: height
        };
      } else {
        if (!this.transition.start.width && this.transition.start.width !== 0) {
          this.transition.start.width = width;
        }
        if (!this.transition.start.height && this.transition.start.height !== 0) {
          this.transition.start.height = height;
        }
      }
      // Set initial transition sizes
      if (!this.transition.end) {
        this.transition.end = {
          set: false,
          width: width,
          height: height
        };
      } else {
        if (!this.transition.end.width && this.transition.end.width !== 0) {
          this.transition.end.width = width;
        }
        if (!this.transition.end.height && this.transition.end.height !== 0) {
          this.transition.end.height = height;
        }
      }
    }

  };

  // Method to set layer offset
  Layer.prototype.setOffset = function(coordinates) {
    this.offset.x = coordinates.x;
    this.offset.y = coordinates.y;
  };

  // Method to set layer position
  Layer.prototype.setPosition = function(coordinates) {
    this.position.x = coordinates.x;
    this.position.y = coordinates.y;
  };

  // Method to scale the layer proportionally
  Layer.prototype.scaleProportionally = function(value, options) {

    options = options || {
      min: -2000,
      max: 2000,
      width: 0,
      ratio: 1
    };

    value = window.parseInt(value, 10);
    value = Math.clamp(value, options.min, options.max);

    var width = Math.floor(options.width + value);
    var height = Math.floor(width * options.ratio);
    var transition = this.transition[this.preview];
    var previous = {
      width: transition.width,
      height: transition.height
    };

    // Min clamp
    if (width < 0) width = 0;
    if (height < 0) height = 0;

    this.setSize(width, height, true);

    transition.x -= Math.floor((width - previous.width) / 2);
    transition.y -= Math.floor((height - previous.height) / 2);
    this.position.x = transition.x;
    this.position.y = transition.y;
    transition.width = width;
    transition.height = height;

    Comic.renderPage();

  };

  // Method to get the layer preview
  Layer.prototype.generateThumbnail = function(type) {
    // Set the default type
    type = type || "image/png";
    var canvas = new Canvas({
      // width: 102, // HACK
      // height: 77 // HACK
    });
    var coordinates = {
      x: 0,
      y: 0
    };
    var offset = {
      x: canvas.element.width,
      y: canvas.element.height
    };
    canvas.drawImage(this.canvas.element, coordinates, offset);
    // Return the thumbnail as a base64 data URI
    return canvas.element.toDataURL(type);
  };

  // Method to update the thumbnail image of the layer
  Layer.prototype.updateThumbnail = function() {
    this.thumbnail = this.generateThumbnail();
  };

  // Method to update the layer data
  Layer.prototype.reassignData = function(data) {

    this.text = data.text;
    this.asset = data.asset;
    this.content = data.content;

    // Reset the canvas contents
    this.canvas.resetCanvas();

    // Draw the image on the canvas
    this.canvas.drawImage(this.content, null, {
      x: this.size.width,
      y: this.size.height
    });

    // Set the initial thumbmail
    this.updateThumbnail();

  };

  // Public / exposed class
  return Layer;

})();
